import { RHFDatePicker, RHFSelect, RHFTextField } from "@components/hook-form";
import { Box, Grid, MenuItem, Typography } from "@mui/material";
import { useCommonStyles } from "../hooks/useCommonStyles";

interface IRecurringInvoiceProps {
  translate: (text: any, options?: any) => string;
}

export const RecurringInvoice = ({ translate }: IRecurringInvoiceProps) => {
  const { inputContainer } = useCommonStyles();

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography variant="h6">
          {translate("recurring_invoice_information")}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Box sx={inputContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <RHFDatePicker
                name="RecurringDocument.startDate"
                label={translate("startDate")}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <RHFDatePicker
                name="RecurringDocument.endDate"
                label={translate("endDate")}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <RHFSelect
                name="RecurringDocument.RecurringFrequencyType"
                label={translate("recurringFrequencyType")}
                size="small"
              >
                <MenuItem value="Monthly">{translate("monthly")}</MenuItem>
                <MenuItem value="Yearly">{translate("yearly")}</MenuItem>
              </RHFSelect>
            </Grid>
            <Grid item xs={12} md={6}>
              <RHFTextField
                name="RecurringDocument.InvoiceDueInDays"
                label={translate("invoiceDueInDays")}
                type="number"
                size="small"
              />
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
};
